<template>
<transition name="slide">
    <div class="task-info-footer" v-if="open" v-cloak>
        <div class="transfer-detail-title">{{$t('language.popup.transferDetails')}}</div>
        <div class="transfer-status-des">
            <div style="float:left;"> {{$t('language.common.from')}}:</div>
            <div style="cursor:pointer;" v-show="itemDetail.sourceCloudType==='Shares'" class="catelog-color transfer-detail-max" @click.stop="toShareCatalog(itemDetail)" :title="itemDetail.sourceNode|getCatalogShare|getCatalogTitle">{{itemDetail.sourceNode|getCatalogShare}}</div>
            <div style="cursor:pointer;" v-show="itemDetail.sourceCloudType!=='Shares'" class="catelog-color transfer-detail-max " @click.stop="toSourceCatalog(itemDetail)" :title="itemDetail.sourceNode|getCatalog|getCatalogTitle">{{itemDetail.sourceNode|getCatalog}}</div>
        </div>
        <div class="transfer-status-des">
            <div style="float:left;"> {{$t('language.common.to')}}:</div>
            <div style="cursor:pointer;" class="catelog-color transfer-detail-max " @click.stop="toAimSourceCatalog(itemDetail)" :title="itemDetail.desNode|getCatalog|getCatalogTitle">{{itemDetail.desNode|getCatalog}}</div>
        </div>
        <div class="transfer-status-des" v-if="itemDetail.status!=3">
            {{$t('language.common.result')}}: <span v-if="itemDetail.errorList.length&&(itemDetail.readyTranFileCount/itemDetail.totalFileCount)*100>=80">{{$t('language.common.patial')}}</span>
            <span v-if="itemDetail.errorList.length&&(itemDetail.readyTranFileCount/itemDetail.totalFileCount)*100<80">{{$t('language.common.failure')}}</span>
            <span v-if="itemDetail.readyTranFileCount==itemDetail.totalFileCount&&itemDetail.totalFileCount">{{$t('language.common.success')}}</span>
        </div>
        <div class="transfer-status-des" v-if="itemDetail.itemProgressInfo">
            <span>{{$t('language.common.fileProcess')}}:{{itemDetail.readyTranFileCount}}/{{itemDetail.totalFileCount}}</span>
            <span class="transfer-success-progress">{{$t('language.common.dataProcess')}}:{{itemDetail.readedBytes|formatByte}}/{{itemDetail.totalBytes|formatByte}}</span>
        </div>
        <div class="transfer-status-des" v-if="itemDetail.itemProgressInfo">
            <span>{{$t('language.common.startTime')}}:{{itemDetail.taskStartTimeLong|transferForMatTime}}</span>
            <span class="transfer-success-progress">{{$t('language.common.endTime')}}:{{itemDetail|getEndTime}}</span>
        </div>
        <div class="transfer-status-des" v-if="itemDetail.itemProgressInfo">{{$t('language.common.averageRate')}}:{{(itemDetail.readedBytes/(itemDetail.taskElaspedTimeLong/1000))|formatByteSpeed}}</div>
        <div class="transfer-failed-footer" @click.stop="openRetryDialog(itemDetail)" v-if="itemDetail.status!=3">{{$t('language.common.viewFailed')}}</div>
    </div>
</transition>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
export default {
    props: ['open', 'index', 'itemDetail'],
    data: function () {
        return {

        }
    },
    methods: {
        openRetryDialog() {
            let that = this;
            let retryFailedDialog = this.$parent.$parent.$parent.$parent.$parent.$refs.retryFailedDialog;
            this.$parent.$parent.$parent.$parent.detailedProgressShow = false;
            retryFailedDialog.selectedArr = [];
            retryFailedDialog.retryShow = true;
            if (this.itemDetail.errorList.length) {
                retryFailedDialog.unfinishData = Object.assign([], this.itemDetail.errorList);
                $.each(this.itemDetail.errorList, function (index, errItem) {
                    errItem.sourceNode = Object.assign([], that.itemDetail.sourceNode);
                    errItem.desCloudType = that.itemDetail.desCloudType;
                    errItem.sourceToken = that.itemDetail.sourceToken;
                    errItem.desNode = Object.assign([], that.itemDetail.desNode);
                    errItem.remove = that.itemDetail.remove;
                    errItem.desToken = that.itemDetail.desToken;
                    delete errItem.retryed;
                });
            } else {
                this.itemDetail.errorList = [];
                let errorList = {
                    fileid: this.itemDetail.sourceId,
                    filename: this.itemDetail.sourceFilename,
                    filesize: this.itemDetail.totalBytes,
                    cloudtype: this.itemDetail.sourceCloudType,
                    tokenid: this.itemDetail.sourceToken,
                    desToken: this.itemDetail.desToken,
                    isDir: this.itemDetail.dir,
                    desid: this.itemDetail.desId,
                    desname: this.itemDetail.desFilename,
                    sourceNode: Object.assign([], this.itemDetail.sourceNode),
                    desCloudType: this.itemDetail.desCloudType,
                    sourceToken: this.itemDetail.sourceToken,
                    desNode: Object.assign([], this.itemDetail.desNode),
                    remove: this.itemDetail.remove,
                    cause: 'error'
                }
                this.itemDetail.errorList.push(errorList);
            }
        },
        toSourceCatalog(itemDetail) {
            // console.log(itemDetail)
            let that = this;
            this.$parent.$parent.$parent.isflage = true;
            let direction = that.$parent.$parent.$parent.$parent.$parent;
            commonUtils.toSourceCatalog(itemDetail, this, function (res) {
                if (res.status == 200) {
                        let pathData = that.$store.state.pathJson[res.id + itemDetail.sourceToken];
                        const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
                        if (!pathData || !pathData.json.length) {
                            $.each(itemDetail.sourceNode,function(j,jIitem){
                                  jIitem.tokenId=itemDetail.sourceToken;
                            });
                            commonUtils.encapsulationPath(itemDetail.sourceNode, pathData, vm);
                        } else {
                            vm.pathJson = pathData.json;
                        }
                        commonUtils.selectOption(itemDetail.sourceNode, direction);
                        that.$store.state.catalogFileId = itemDetail.sourceNode[0].fileId;
                        commonUtils.ifHasDataSelect(vm);
                        //关闭弹窗
                        that.$store.state.detaleProgressShow=false;
                }
            });
        },
        toAimSourceCatalog(itemDetail) {
            let that = this;
            this.$parent.$parent.$parent.isflage = true;
            let direction = that.$parent.$parent.$parent.$parent.$parent;
            commonUtils.toAimSourceCatalog(itemDetail, this, function (res) {
                if (res.status == 200) {
                        commonUtils.selectOption(itemDetail.desNode, direction);
                        let pathData = that.$store.state.pathJson[res.id + itemDetail.desToken];
                        const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
                        if (!pathData || !pathData.json.length) {
                            commonUtils.encapsulationPath(itemDetail.desNode, pathData, vm);
                        } else {
                            vm.pathJson = pathData.json;
                        }
                        //关闭弹窗
                        that.$store.state.detaleProgressShow=false;
                }
            });
        },
        toShareCatalog(itemDetail){
            let allNodes = itemDetail.sourceNode;
            let nodes = commonUtils.getSharePathForCryptId(itemDetail);
            if(nodes){
                this.$store.commit("setSharePath", nodes);
            }
            let link = commonstate.sharePageUrl + allNodes[allNodes.length-1].shareId;
            window.open(link);
        },
    },

}
</script>

<style>
.transfer-failed-footer {
    font-size: 12px;
    /*no*/
    color: red;
}

.transfer-failed-footer:hover {
    text-decoration: underline;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_detailed_progress/tab_unfinished_detail.vue